import { render } from "./PriceTable.vue?vue&type=template&id=3ce324e2&scoped=true&ts=true"
import script from "./PriceTable.ts?vue&type=script&lang=ts"
export * from "./PriceTable.ts?vue&type=script&lang=ts"

import "./PriceTable.scss?vue&type=style&index=0&id=3ce324e2&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce324e2"]])

export default __exports__